import { apiPost } from '@/store/actions'

const setLoginEmail = (context: any, payload: string) => {
  context.commit('SET_LOGIN_EMAIL', payload)
}

const setIsDisplayTosCheckbox = (context: any, payload: string) => {
  context.commit('SET_IS_DISPLAY_TOS_CHECKBOX', payload)
}

const signInByEmailLink = async (context: any, payload: { code: string }) => {
  const { data } = await apiPost(context, '/auth/signin-by-link', payload)
  return data
}

const sendSignInByEmailLink = async (
  context: any,
  payload: { email: string; redirect_path?: string }
) => {
  const { data } = await apiPost(context, '/auth/send-signin-link', payload)
  return data
}

const sendResetPasswordLink = async (context: any, email: string) => {
  const { data } = await apiPost(context, '/auth/send-password-reset-link', {
    email
  })
  return data
}

const resetPassword = async (
  context: any,
  payload: { code: string; new_password: string }
) => {
  const { data } = await apiPost(context, '/auth/reset-password', payload)
  return data
}

const verifyPasswordReset = async (context: any, payload: { code: string }) => {
  const { data } = await apiPost(
    context,
    '/auth/verify-password-reset-code',
    payload
  )
  return data
}

const validateEmail = async (context: any, payload: { email: string }) => {
  const { data } = await apiPost(context, '/auth/validate-email', payload)
  return data
}

const updateImageProfile = async (context: any, payload: { image: Blob }) => {
  const params = new FormData()
  params.append('image', payload.image)
  const { data } = await apiPost(context, 'users/update-profile-image', params)
  return data
}

const deleteImageProfile = async (context: any) => {
  const { data } = await apiPost(context, 'users/delete-profile-image')
  return data
}

export default {
  setLoginEmail,
  setIsDisplayTosCheckbox,
  signInByEmailLink,
  sendSignInByEmailLink,
  sendResetPasswordLink,
  resetPassword,
  verifyPasswordReset,
  validateEmail,
  updateImageProfile,
  deleteImageProfile
}
